/**
 * @description A dropdown of Flow / Step variables to insert into a text field
    <variable-select ></variable-select>
 */
import angular from 'angular';

angular.module('flowingly.components').component('variableSelect', {
  bindings: {
    targetId: '<', // Id of the input the variables are inserted into
    steps: '<', // Array of steps and their available field names
    enabled: '<',
    onValueSelected: '&', // Callback (selectedVariable:string, targetElementId:string)=>void
    isPublicForm: '<'
  },
  controller: function () {
    this.dropDownId = `${this.targetId}-variable-select`;
    this.toggleDropDown = () => {
      $('#' + this.dropDownId).slideToggle(150);
    };

    this.toggleVariableGroup = ($event) => {
      const groupHeader = $($event.currentTarget);
      groupHeader.toggleClass('variable-group-collapsed');
      const dropdown = groupHeader.next('.variable-dropdown');
      dropdown.slideToggle(150);
    };

    this.selectVariable = ($event) => {
      this.toggleDropDown();

      const variable = escapeSpecialChar(
        $event.currentTarget.attributes['data-item-value'].value
      );
      this.onValueSelected({ variable: variable, inputId: this.targetId });
    };

    function escapeSpecialChar(value) {
      value = value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
      return value;
    }
  },
  template: `
      <a ng-click="$ctrl.enabled && $ctrl.toggleDropDown()"
          class="btn"
          ng-class="{
              'blue waves-effect waves-light': $ctrl.enabled,
              grey: !$ctrl.enabled
            }">Add Variable</a>
      <div class="variable-all-group" id="{{$ctrl.dropDownId}}">
          <div class="variable-group">
              <div class="variable-group-header variable-group-collapsed" ng-click="$ctrl.toggleVariableGroup($event)"><span>Flow Attributes</span></div>
              <ul class="variable-dropdown">
                  <li ng-if="!$ctrl.isPublicForm" ng-click="$ctrl.selectVariable($event)" data-item-value="{flow.subject}"><span>Subject</span></li>
                  <li ng-click="$ctrl.selectVariable($event)" data-item-value="{flow.initiatorFullName}"><span>Initiator Full Name</span></li>
                  <li ng-click="$ctrl.selectVariable($event)" data-item-value="{flow.initiatorEmail}"><span>Initiator Email</span></li>
                  <li ng-click="$ctrl.selectVariable($event)" data-item-value="{flow.initiatorManager}"><span>Initiator Manager</span></li>
                  <li ng-click="$ctrl.selectVariable($event)" data-item-value="{flow.initiatorPhoneNumber}"><span>Initiator Phone Number</span></li>
                  <li ng-if="!$ctrl.isPublicForm" ng-click="$ctrl.selectVariable($event)" data-item-value="{flow.status}"><span>Status</span></li>
                  <li ng-if="!$ctrl.isPublicForm" ng-click="$ctrl.selectVariable($event)" data-item-value="{flow.nextStep}"><span>Next Step</span></li>
                  <li ng-if="!$ctrl.isPublicForm" ng-click="$ctrl.selectVariable($event)" data-item-value="{flow.dueDate}"><span>Due Date</span></li>
                  <li ng-click="$ctrl.selectVariable($event)" data-item-value="{flow.flowModelName}"><span>Flow Model Name</span></li>
                  <li ng-if="!$ctrl.isPublicForm" ng-click="$ctrl.selectVariable($event)" data-item-value="{flow.flowId}"><span>Flow ID</span></li>
                  <li ng-if="!$ctrl.isPublicForm" ng-click="$ctrl.selectVariable($event)" data-item-value="{flow.progress}"><span>Progress</span></li>
                  <li ng-if="!$ctrl.isPublicForm" ng-click="$ctrl.selectVariable($event)" data-item-value="{flow.link}"><span>Flow Link</span></li>
              </ul>
          </div>
          <div ng-repeat="step in $ctrl.steps" class="variable-group">
              <div class="variable-group-header variable-group-collapsed" ng-click="$ctrl.toggleVariableGroup($event)"><span>{{step.stepName}}</span></div>
              <ul class="variable-dropdown">
                  <li ng-repeat="fieldName in step.fieldNames" ng-click="$ctrl.selectVariable($event)"
                      data-item-value="{step.{{step.stepName}}.{{fieldName}}}">
                      <span title='{{fieldName}}'>{{fieldName}}</span>
                  </li>
                  <li ng-if="step.isStepTaskEnabled" ng-click="$ctrl.selectVariable($event)" data-item-value="{stepTask.{{step.stepName}}}"><span>Step Tasks</span></li>
              </ul>
          </div>
      </div>`
});
